import {useState, useRef} from 'react';

import useToggle from './useToggle';
import useOutsideClick from './useOutsideClick';

const useSearchWidgetUI = ({initailCalendarMode = ''} = {}) => {
  const calendarBlockRef = useRef(null);
  const paxWidgetBlockRef = useRef(null);

  const [calendarMode, setCalendarMode] = useState(initailCalendarMode);
  const [isCalendarClose, setIsCalendarClose] = useState(false);

  const [isPaxWidgetVisible, togglePaxWidgetVisible] = useToggle(false);

  const toggleCheckinCalendar = () => {
    if (calendarMode !== 'checkin') {
      setCalendarMode('checkin');
      setIsCalendarClose(true);
    } else {
      setCalendarMode('');
      setIsCalendarClose(false);
    }
  };

  const toggleCheckoutCalendar = () => {
    if (calendarMode !== 'checkout') {
      setCalendarMode('checkout');
      setIsCalendarClose(true);
    } else {
      setCalendarMode('');
      setIsCalendarClose(false);
    }
  };

  const closeCalendar = () => {
    setCalendarMode('');
    setIsCalendarClose(false);
  };

  const togglePaxWidget = val => {
    togglePaxWidgetVisible(val);
    if (val && isPaxWidgetVisible) closeCalendar();
  };

  useOutsideClick(calendarBlockRef, () => {
    if (calendarMode === 'checkin' || calendarMode === 'checkout') {
      setIsCalendarClose(true);
    }
    setCalendarMode('');
  });

  useOutsideClick(paxWidgetBlockRef, () => {
    togglePaxWidget(false);
  });

  return {
    calendarBlockRef,
    paxWidgetBlockRef,
    calendarMode,
    isCalendarClose,
    toggleCheckinCalendar,
    toggleCheckoutCalendar,
    closeCalendar,
    setCalendarMode,
    isPaxWidgetVisible,
    togglePaxWidget,
  };
};

export default useSearchWidgetUI;
